import styled from "styled-components";
import { X } from "lucide-react";
import { Button } from "./Button";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
  animation: fadeIn 0.2s ease;
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const Dialog = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  max-width: ${({ $maxWidth }) => $maxWidth || "480px"};
  width: 100%;
  max-height: calc(100vh - 48px);
  overflow: auto;
  animation: slideUp 0.2s ease;
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 0;
  margin-bottom: 16px;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text?.heading || "#111827"};
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: #f3f4f6;
  border-radius: 10px;
  cursor: pointer;
  color: #6b7280;
  &:hover {
    background: #e5e7eb;
    color: #374151;
  }
`;

const Body = styled.div`
  padding: 0 20px 20px;
`;

export function Modal({ open, onClose, title, children, maxWidth }) {
  if (!open) return null;
  return (
    <Overlay onClick={(e) => e.target === e.currentTarget && onClose?.()}>
      <Dialog $maxWidth={maxWidth} onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>{title}</Title>
          <CloseBtn type="button" onClick={onClose} aria-label="Close">
            <X size={20} />
          </CloseBtn>
        </Header>
        <Body>{children}</Body>
      </Dialog>
    </Overlay>
  );
}
